// Centralized content scraped/derived from tecnografic.com

export const COMPANY = {
  name: "Tecnografic",
  tagline: "Precision Marine Manufacturing Since 1998",
  shortAbout:
    "A trusted OEM partner to the largest US and overseas boat builders, delivering custom dashboards, switch panels and marine components engineered for the harshest environments.",
  address: {
    street: "1010 NW 51st Place",
    city: "Fort Lauderdale, FL 33309",
    country: "United States",
  },
  phone: "954-928-1714",
  fax: "954-928-1785",
  email: "info@tecnografic.com",
  facility: "13,000 sq ft facility in Fort Lauderdale, FL",
  yearsInIndustry: "25+ Years in the Marine Industry",
  logo: "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/01/logo-1-300x59.png",
};

export const STATS = [
  { value: "25+", label: "Years in the Marine Industry" },
  { value: "13,000", label: "Sq Ft Manufacturing Facility" },
  { value: "1000+", label: "Hydro Dip Patterns in Stock" },
  { value: "5 yr", label: "Minimum Warranty on Finish" },
];

export const SERVICES = [
  {
    slug: "design",
    title: "Design",
    short:
      "Pioneers in form & function. Our designers translate every brief into attractive, durable marine products.",
    bullets: [
      "Customer-centric design process",
      "Substrate selection guidance",
      "Fit, mounting & finish advisory",
      "Environmental + quality constraints handled in-house",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/07/design.png",
  },
  {
    slug: "engineering",
    title: "Engineering",
    short:
      "Modern, precision software paired with experienced engineers — every piece designed with the end user in mind.",
    bullets: [
      "3D-CAD SolidWorks® & AutoCAD®",
      "CNC Milling & Routing",
      "Laser cutter and engravers",
      "Rotary engraving",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/07/engineering5-CNC.png",
  },
  {
    slug: "manufacture",
    title: "Manufacture",
    short:
      "13,000 sq ft of in-house manufacturing in Fort Lauderdale, FL — built to customer spec, to the highest industry quality standard.",
    bullets: [
      "Made-to-order, no minimum quantity",
      "UV-stable & salt-spray resistant",
      "5-year minimum warranty against fade or delamination",
      "Fastest manufacturing timeframe in the industry",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/07/manufacture.png",
  },
  {
    slug: "oem",
    title: "OEM",
    short:
      "A trusted Original Equipment Manufacturer to US and overseas boat builders since 1998 — instrument, switch and electronic dash panels.",
    bullets: [
      "Trusted by the largest boat builders worldwide",
      "Marine & automotive instrument panels",
      "Consistent quality, fast lead times",
      "5-year minimum warranty",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/07/OEM.png",
  },
  {
    slug: "aftermarket",
    title: "Aftermarket — Custom Projects",
    short:
      "Replace, refresh, refurbish. We design and manufacture custom boat parts for owners and installers — from one-off reproductions to brand-new conceptions.",
    bullets: [
      "Largest template library of new & used boat models",
      "Replace faded, cracked or outdated panels",
      "Cutouts for new gauges, switches & electronics",
      "Flush mounting & glass-look helms",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/09/JAY_9010-300x200.jpg",
  },
  {
    slug: "hydro-dip",
    title: "Hydro Dip",
    short:
      "Sole North American licensee of Taica's CUBIC printing technology in the marine sector. Over 1,000 unique patterns on metal or plastic.",
    bullets: [
      "Wood grain, carbon fiber, brushed aluminum, stone, camo",
      "5-step ink water transfer process",
      "Chemically bonded — UV stable, scratch resistant",
      "Browse the library at hydrofablab.com",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/07/hydro-drip.png",
  },
  {
    slug: "accessorize",
    title: "Accessorize",
    short:
      "Engraving, backlighting, silk screening and bespoke hardware to elevate every helm station.",
    bullets: [
      "EL wire & LED backlighting recessed and installed",
      "Silk screening for logos, labels & icons",
      "Flat mounting kits for flush-mounted electronics",
      "Threaded studs for a screwless finish",
    ],
    image:
      "https://tecnograficcom.wpengine.com/wp-content/uploads/2023/07/accessorize.png",
  },
];

export const CAPABILITIES = [
  {
    title: "3D-CAD Engineering",
    detail: "SolidWorks® & AutoCAD® for every part.",
  },
  { title: "CNC Milling & Routing", detail: "Precision-machined substrates." },
  { title: "Laser Cutting & Engraving", detail: "Crisp text, icons & cutouts." },
  { title: "Hydrographic Dipping", detail: "Taica CUBIC printing licensee." },
  {
    title: "Spray Booth & Paint",
    detail: "500+ marine-grade urethane colors in stock.",
  },
  {
    title: "Silk Screening & Print",
    detail: "Vinyl, epoxy, sublimation & 3D print.",
  },
  { title: "Powder Coating", detail: "Anodizing & heat curing equipment." },
  { title: "Backlighting", detail: "EL wire & LED for night boating." },
];

export const SUBSTRATES = [
  "Polycarbonate (Lexan)",
  "Acrylic (Plexiglass)",
  "PVC",
  "Aluminum",
  "Stainless Steel",
  "Wood",
];

export const PROCESS = [
  {
    step: "01",
    title: "Brief & Template",
    body: "Share your boat make/model or upload photos. Our template library covers the largest catalogue of new & used boats.",
  },
  {
    step: "02",
    title: "Design & Engineering",
    body: "Our designers and engineers refine the geometry, cutouts, mounting and finish to suit the end-use.",
  },
  {
    step: "03",
    title: "Substrate & Finish",
    body: "Pick from Lexan, acrylic, aluminum, stainless and more — then paint, hydro dip, engrave or backlight.",
  },
  {
    step: "04",
    title: "Manufacture & Ship",
    body: "Made-to-order in our Fort Lauderdale facility and shipped fast — no minimum order quantity.",
  },
];

// Brands we have worked with (logos from original site)
export const BRANDS = [
  { name: "Boston Whaler", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/boston-whaler-320x202.png" },
  { name: "Sea Ray", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/searay-320x202.png" },
  { name: "Tiara Yachts", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/tiara-yachts-320x202.png" },
  { name: "Scout Boats", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/scout-boats-e1692301504997-320x202.png" },
  { name: "Riviera", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/riviera-320x202.png" },
  { name: "Regulator", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/regulator-320x202.png" },
  { name: "Midnight Express", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/midnight-express-320x202.png" },
  { name: "Maverick", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/maverick-320x202.png" },
  { name: "Jupiter", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/jupiter-320x202.png" },
  { name: "Formula", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/formula-320x202.png" },
  { name: "Everglades", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/everglades-320x202.png" },
  { name: "Cruiser Yachts", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/cruiser-yachts-320x202.png" },
  { name: "Cobalt", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/cobalt-320x202.png" },
  { name: "Chris-Craft", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/chris-and-craft-320x202.png" },
  { name: "Bertram", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/bertram-320x202.png" },
  { name: "Shearwater", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/shearwater-320x202.png" },
  { name: "Neptune Yachts", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/neptune-yachts-320x202.png" },
  { name: "Liberty Coach", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/liberty-coach-320x202.png" },
  { name: "Daimler", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/daimler-320x202.png" },
  { name: "AB Inflatables", logo: "https://www.tecnografic.com/wp-content/uploads/2023/07/AB-320x202.png" },
];

export const PORTFOLIO_ITEMS = [
  {
    id: 1,
    title: "Carbon Fiber Helm Panel",
    category: "Hydro Dip",
    tag: "hydro",
    image: "https://images.unsplash.com/photo-1518684079-3c830dcef090?w=1200&q=80",
  },
  {
    id: 2,
    title: "Custom Backlit Switch Panel",
    category: "Accessorize",
    tag: "custom",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/07/backlight-2.png",
  },
  {
    id: 3,
    title: "OEM Dashboard Build",
    category: "Manufacture",
    tag: "dash",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/09/JAY_9010-resized.jpg",
  },
  {
    id: 4,
    title: "Wood Grain Hydro Finish",
    category: "Hydro Dip",
    tag: "hydro",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/07/hyrdo1.png",
  },
  {
    id: 5,
    title: "CNC-Milled Dash",
    category: "Engineering",
    tag: "dash",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/07/engineering5-CNC.png",
  },
  {
    id: 6,
    title: "Engraved Trim Detail",
    category: "Accessorize",
    tag: "custom",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/07/backlight-7.png",
  },
  {
    id: 7,
    title: "Brushed Aluminum Pattern",
    category: "Hydro Dip",
    tag: "hydro",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/07/hyrdo2.png",
  },
  {
    id: 8,
    title: "Painted Helm Surface",
    category: "Paint & Print",
    tag: "dash",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/08/paint1.png",
  },
  {
    id: 9,
    title: "Substrate Detail",
    category: "Substrates",
    tag: "custom",
    image: "https://www.tecnografic.com/wp-content/uploads/2023/07/substrates-3.png",
  },
];

export const PROJECT_TYPES = [
  "OEM Production",
  "Aftermarket / Custom",
  "Hydro Dip",
  "Engraving & Backlighting",
  "Refurbishment",
  "Other",
];
